import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=39700c10&scoped=true"
import script from "./addTask.vue?vue&type=script&lang=js"
export * from "./addTask.vue?vue&type=script&lang=js"
import style0 from "./addTask.vue?vue&type=style&index=0&id=39700c10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39700c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39700c10')) {
      api.createRecord('39700c10', component.options)
    } else {
      api.reload('39700c10', component.options)
    }
    module.hot.accept("./addTask.vue?vue&type=template&id=39700c10&scoped=true", function () {
      api.rerender('39700c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programTask/components/addTask.vue"
export default component.exports